import { H3 } from '@h3/types';
export namespace FlowCenter {
    /** 流程中心流程数据分类(即流程中心前端页面上的页签) */
    export enum WorkflowClassification {
        /** 待办 */
        Todo = 'todo',

        /** 待阅 */
        ToRead = 'toread',

        /** 我发起的 */
        Apply = 'apply',

        /** 已办 */
        Done = 'done',

        /** 全部 */
        All = 'all',
    }

    /** 流程中心按钮类型 */
    export enum WorkflowActionType {
        /** 详情 */
        Detail = 'detail',

        /** 进入处理 */
        GoHandle = 'goHandle',

        /** 已阅 */
        MarkAsRead = 'markAsRead',

        /** 进入审批 */
        GoApproval = 'goApproval',

        /** 按钮 */
        Button = 'button',
    }

    /** 流程中心筛选状态值 */
    export enum WorkflowStatusKey {
        /** 全部 */
        All = '0',
        /** 我发起的 */
        Mine = '1',
        /** 待办 */
        Todo = '2',
        /** 已办 */
        Done = '3',
        /** 待阅 */
        Toread = '4',
        /** 已阅 */
        Readed = '5',
        /** 进行中 */
        Working = '6',
        /** 已作废 */
        Canceled = '7',
    }

    /** 流程中心列表字段排序 */
    export enum SortDirection {
        /** 升序 */
        ASC = 0,

        /** 降序 */
        DESC = 1,
    }

    /** 待办中批量操作的弹框类型 */
    export enum BatchModalType {
        Agree = 'agree',
        Disagree = 'disagree',
        Close = 'close',
    }

    /** 审批状态 */
    export enum ApprovalStatus {
        Success = 'success',
        Fail = 'fail',
    }

    /** 审批结果类型 */
    export interface IApprovalResults {
        id: string;
        title: string;
        status: ApprovalStatus;
        message?: string;
    }

    export interface IExtraData {
        /** 排序字段名称 */
        ItemCode: string;
        /** 排序类型 */
        SortDirection: SortDirection;
    }

    /** 筛选数据结构 */
    export interface IFilterData {
        belongApp: H3.FunctionNode.IFunctionNode[];
        belongAppStr: string;
        receiveTime: string[];
        finishTime: string[];
        creator: H3.Org.IOrgInfo[];
        creatorStr: string;
        workflowStatus: WorkflowStatusKey;
        keyWord: string;
    }

    /** 流程中心列表数据结构 */
    export interface IWorkflowFormData {
        AppCode: string;
        Code: string;
        DirtyProperties: string[];
        DisplayName: string;
        EnableDataAcl: boolean;
        IconColorIndex: number;
        IconCss: string;
        IsAppSetting: boolean;
        IsWorkflowModule: boolean;
        IsWorkflowNode: boolean;
        NodeType: number;
        NodeVisible: number;
        ObjectId: string;
        ParentCode: string | null;
        ParentIndex: number;
        ParentObjectId: string | null;
        ParentPropertyName: string | null;
        Removable: boolean;
        Serialized: boolean;
        SortKey: number;
        State: number;
        Url: string;
        Visible: boolean;
        children: IWorkflowCategorys[];
    }

    export interface IWorkflowCategorys {
        AppCode: string;
        ChildMyworkflow: string[];
        DisplayName: string;
        IconCss: string;
        SortKey: number;
        WorkflowCode: string;
        WorkflowVeision: string | null;
    }

    export interface IControlsOptions {
        /** 控件对应字段编码 */
        DataField: string;
        /** 控件类型 */
        ControlKey: H3.Control.FormControlKeys;
        /** 控件显示名称 */
        DisplayName: string;
        /** 控件描述 */
        Description: string;
        /** 控件转换 */
        TransferItems: H3.Control.FormControlKeys;
        /** 隐藏规则 */
        DisplayRule: H3.Control.ControlDesigner.Rule;
        SelectShowMode: H3.Control.SelectShowMode;
        /** 默认选项 */
        DefaultItems: string[];
        /** 默认值 */
        DefaultValue: string;
        /** 颜色开关 */
        ColorSwitch: boolean;
        /** 选项颜色 */
        ItemColors: H3.Control.ColorSelectItem[];
    }

    export interface IColorControls {
        Key: string;
        ParentKey: string;
        Options: IControlsOptions;
        Type: number;
        TabGroupKey: string;
        ChildControls: IColorControls[];
    }

    export interface ISummaryControls {
        controlKey: string;
        label: string;
        value: string;
        colorSwitch: boolean;
        itemColors: H3.Control.ColorSelectItem[];
        controlType?: number;
        entryIds?: string;
    }

    export namespace Response {
        /** 获取待办数量响应 */
        export interface TodoCount {
            /** 我发起的数量 */
            myInstanceCount: number;

            /** 待办数量 */
            unFinishedCount: number;

            /** 待阅数量 */
            unReadCount: number;
        }
    }

    export namespace Request {
        /** 调用接口时传入的数据类型枚举 */
        export enum WorkflowHomeDataType {
            /** 我发起的 */
            MyInstance = 3,

            /** 待办 */
            UnFinished = 1,

            /** 待阅 */
            UnRead = 2,

            /** 全部 */
            All = 0,
        }

        /** 流程分类到数据类型映射 */
        export const MapClassificationToDataType: Record<WorkflowClassification, WorkflowHomeDataType> = {
            [WorkflowClassification.All]: WorkflowHomeDataType.All,
            [WorkflowClassification.Apply]: WorkflowHomeDataType.MyInstance,
            [WorkflowClassification.Done]: WorkflowHomeDataType.All,
            [WorkflowClassification.ToRead]: WorkflowHomeDataType.UnRead,
            [WorkflowClassification.Todo]: WorkflowHomeDataType.UnFinished,
        };
    }
}
